<template>
  <div>
    <el-table
      :data="records"
      border
      size="mini"
      v-loading="loading"
      element-loading-text="正在加载中～"
    >
      <el-table-column label="编号" prop="complaintNo" align="center">
        <template slot-scope="scope">
          <el-link
            type="success"
            :underline="false"
            :href="`/customer/complaint/detail?id=${scope.row.id}`"
            target="_blank"
            class="font-12 font-normal"
            >{{ scope.row.complaintNo }}</el-link
          >
        </template>
      </el-table-column>
      <el-table-column label="类型" prop="typeName" align="center" width="90" />
      <el-table-column label="来源" prop="resName" align="center" width="120" />
      <el-table-column label="责任部门" prop="merchantName" align="center" />
      <el-table-column label="处理状态" prop="statusName" align="center" width="140" />
      <el-table-column label="反馈时间" prop="createTime" align="center" />
      <el-table-column label="反馈内容" prop="remark" align="center" />
    </el-table>
    <div style="display: flex; justify-content: right; margin-right: 20px; margin-top: 20px">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="paginationObj.current"
        :page-size="paginationObj.size"
        background
        layout="prev, pager, next"
        :total="total"
        size="mini"
      />
    </div>
  </div>
</template>

<script>
  import { userComplaintPage } from '@/api'
  export default {
    props: {
      suggestion: {
        type: Object,
        default: () => {}
      },
      userId: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        records: [],
        total: 0,
        paginationObj: {
          current: 1,
          size: 5
        },
        loading: false,
        pkgViewVisible: false
      }
    },
    mounted() {
      this.records = this.suggestion.records || []
      this.total = this.suggestion.total || 0
    },
    methods: {
      handlePkgView(id) {
        this.pkgViewVisible = true
        this.$nextTick(() => {
          this.$refs.pkgView.init(id)
        })
      },
      closeLoading() {
        this.$loading().close()
      },
      previewInvoice(url) {
        location.href = url
      },
      async getPage() {
        this.loading = true
        const params = {
          ...this.paginationObj,
          createBy: this.userId,
          state: this.state
        }
        const { code, data } = await userComplaintPage(params)
        if (code === 0) {
          const { total, records } = data
          this.records = records
          this.total = total
          this.loading = false
        }
      },
      handleCurrentChange(e) {
        this.paginationObj.current = e
        this.getPage()
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .el-link.el-link--success {
    color: #22c655;
  }
</style>
